import script from "./langSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./langSelector.vue?vue&type=script&lang=ts&setup=true"

import "./langSelector.vue?vue&type=style&index=0&id=8d845652&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d845652"]])

export default __exports__